<template>
  <div class="text-validator">
    <div class="text8" v-if="title">{{ title }}</div>
    <div v-for="(rule, index) in rules" :key="index" class="rule">
      <span class="icon">
        <FontIcon :name="iconName(rule)" :class="iconName(rule)" />
      </span>
      <span class="text text8">
        {{ $t(rule.name) }}
      </span>
    </div>
  </div>
</template>

<style lang="scss">
.text-validator {
  margin-bottom: rem(24px);
  .rule {
    .icon {
      vertical-align: sub;

      .ui_status_error {
        @include setColor(--color-status-error);
      }
      .ui_done {
        @include setColor(--color-status-success);
      }
    }
    .text {
      margin-left: rem(5px);
    }
  }
}
</style>

<script>
import FontIcon from "../../FontIcon/FontIcon";
export default {
  name: "TextValidator",

  components: {
    FontIcon,
  },

  props: {
    title: {
      type: String,
    },
    rules: {
      type: Array,
      default() {
        return [
          {
            name: "length",
            regex: "^.{8,}",
          },
          {
            name: "lowercase",
            regex: "[a-z]+",
          },
          {
            name: "uppercase",
            regex: "[A-Z]+",
          },
          {
            name: "special",
            regex: "[0-9?!@]+",
          },
        ];
      },
    },
    value: {
      validator: prop => typeof prop === "string" || prop === null,
      required: true,
    },
  },

  watch: {
    value() {
      this.$emit("isValid", this.matchAll());
    },
  },

  methods: {
    match(strRegex) {
      const regex = new RegExp(strRegex);
      return (this.value && regex.test(this.value)) || false;
    },
    matchAll() {
      if (!this.value) return false;

      let result = true;
      this.rules.forEach(rule => {
        result = result && this.match(rule.regex);
      });

      return result;
    },
    iconName(rule) {
      return !this.value
        ? "ui_status_cancelled"
        : this.match(rule.regex)
        ? "ui_done"
        : "ui_status_error";
    },
  },
};
</script>
